import { gql } from '@apollo/client/core'
export const similarProductsQuery = gql`
  query getSimilarProducts($id: ID!, $offset: Int!, $limit: Int!, $type: String!) {
  similarProductsBy(id: $id, offset: $offset, limit: $limit, type: $type) {
    totalItemsCount
    offset
    limit
    items {
      id
      displayName
      shortDisplayName
      categoryId
      lowestPrice
      quantityUnit
      brand
      url
      skus {
        psi
        skuImage {
          thumbnail
        }
      }
      gender
    }
  }
}
`
export const productDetailQuery = gql`
  query productDetail(
    $id: ID!,
    $sizes: String,
    $firstOptionId: ID,
    $skuColorPatternId: ID,
    $skuEditPatternId: ID,
    $psi: ID,
    $addonProductId: ID,
    $addonFirstOptionId: ID,
    $addonPsi: ID,
    $userDesignVersionUuid: String,
    $prefectureId: ID
    $optionIds: [ID!]
    $shipping: ProductDetailShippingEnum
  ) {
    productByPrintableSku(
      id: $id,
      sizes: $sizes,
      firstOptionId: $firstOptionId,
      skuColorPatternId: $skuColorPatternId,
      skuEditPatternId: $skuEditPatternId,
      psi: $psi,
      addonProductId: $addonProductId,
      addonFirstOptionId: $addonFirstOptionId,
      addonPsi: $addonPsi,
      resetInvalidSizeInput: true,
      prefectureId: $prefectureId,
      optionIds: $optionIds,
      shipping: $shipping
    ) {
      estimate {
        sizeItems {
          quantity
          sizeId
          sizeName
        }
        productId
        amount
        printableSkuId
        quantity
        quantityUnit
        shortestShippingDate
        convenienceStoreShortestShippingDate
        shortestDeliveryDate
        convenienceStoreShortestDeliveryDate
        plateChargeTaxIncluded
        productUnitPriceTaxIncluded
        unitPriceTaxIncluded
        productPriceTaxIncluded
        addonPriceTaxIncluded
        printingPriceTaxIncluded
        fastShippingFeeTaxIncluded
        fastShippingUnitFeeTaxIncluded
        addonPrintableSkuId
        selectedAddonProductId
        selectedAddonProductName
        selectedAddonFirstOptionId
        selectedAddonQuantityUnit
        addonProductUnitPriceTaxIncluded
        firstSelectedOption {
          id
          displayName
          skuSelection {
            displayName
          }
        }
        secondSelectedOption {
          id
        }
        wrappingSelectedOption {
          id
        }
        selectedColorPattern {
          id
          colorPattern {
            displayName
            lead
            type
            image
          }
        }
        selectedEditPattern {
          id
          editPattern {
            displayName
            lead
            image
          }
        }
        options {
          id
          displayName
          priceTaxIncluded
          totalPriceTaxIncluded
        }
      }
      addedToEstimate
      printableSkuId
      skuPrintableSpecialColors {
        id
        displayName
        spotColor {
          id
          red
          green
          blue
        }
      }
      skuPrintableCmykColors {
        id
        displayName
        spotColor {
          id
          red
          green
          blue
        }
      }
      product {
        id
        categoryId
        category {
          displayName
          url
        }
        industry {
          industryName
        }
        brand
        brandName
        description
        displayName
        precaution
        hasAddonProducts
        hasOptions
        fastShippingProductId
        normalProductId
        fastShippingMarkup
        plainGoodFastShippingMarkup
        gender
        lowestPrice
        publishStatus
        productCardItems {
          productCardDisplayName
          color
        }
        plainGoodFastShipping
      }
      sku {
        id
        facetValues
        availableSizes {
          id
          name
          displayOrder
          hasStock
          maxQuantity
          publishStatus
          restockDate
        }
        mappedSizeSpecs {
          size
          part
          from
          to
        }
        skuEditPatterns {
          id
          editPattern {
            displayName
            lead
            image
          }
        }
        skuColorPatterns {
          id
          colorPattern {
            displayName
            lead
            type
            image
          }
        }
        composition
        materialName
        skuImages {
          id
          caption
          displayOrder
          thumbnail
          imageType
        }
        firstOptions {
          id
          displayName
          selectable
          thumbnail
          lead
        }
        allSkuEditPatterns {
          id
          editPattern {
            displayName
            lead
            image
          }
        }
      }
      searchTags {
        displayName
        categoryUrl
        firstConditionValue
        secondConditionType
        secondConditionValue
      }
    }
    userDesignVersion(uuid: $userDesignVersionUuid) {
      uuid
      imageUrl
    }
  }
`
export const productSkuQuery = gql`
  query productSku(
    $id: ID!,
    $sizes: String,
    $firstOptionId: ID,
    $skuColorPatternId: ID,
    $skuEditPatternId: ID,
    $psi: ID,
    $addonProductId: ID,
    $addonFirstOptionId: ID,
    $addonPsi: ID,
    $prefectureId: ID,
    $optionIds: [ID!]
  ) {
    productByPrintableSku(
      id: $id,
      sizes: $sizes,
      firstOptionId: $firstOptionId,
      skuColorPatternId: $skuColorPatternId,
      skuEditPatternId: $skuEditPatternId,
      psi: $psi,
      addonProductId: $addonProductId,
      addonFirstOptionId: $addonFirstOptionId,
      addonPsi: $addonPsi,
      resetInvalidSizeInput: true,
      prefectureId: $prefectureId,
      optionIds: $optionIds

    ) {
      estimate {
        productId
        sizeItems {
          quantity
          sizeId
          sizeName
        }
        amount
        printableSkuId
        quantity
        quantityUnit
        shortestShippingDate
        convenienceStoreShortestShippingDate
        shortestDeliveryDate
        convenienceStoreShortestDeliveryDate
        plateChargeTaxIncluded
        productUnitPriceTaxIncluded
        unitPriceTaxIncluded
        productPriceTaxIncluded
        addonPriceTaxIncluded
        printingPriceTaxIncluded
        fastShippingFeeTaxIncluded
        fastShippingUnitFeeTaxIncluded
        addonPrintableSkuId
        selectedAddonProductId
        selectedAddonProductName
        selectedAddonFirstOptionId
        selectedAddonQuantityUnit
        addonProductUnitPriceTaxIncluded
        firstSelectedOption {
          id
          displayName
          skuSelection {
            displayName
          }
        }
        secondSelectedOption {
          id
        }
        wrappingSelectedOption {
          id
        }
        selectedColorPattern {
          id
          colorPattern {
            displayName
            lead
            type
            image
          }
        }
        selectedEditPattern {
          id
          editPattern {
            displayName
            lead
            image
          }
        }
        options {
          id
          displayName
          priceTaxIncluded
          totalPriceTaxIncluded
        }
      }
      printableSkuId
      skuPrintableSpecialColors {
        id
        displayName
        spotColor {
          id
          red
          green
          blue
        }
      }
      skuPrintableCmykColors {
        id
        displayName
        spotColor {
          id
          red
          green
          blue
        }
      }
      sku {
        id
        facetValues
        availableSizes {
          id
          name
          displayOrder
          hasStock
          maxQuantity
          publishStatus
          restockDate
        }
        mappedSizeSpecs {
          size
          part
          from
          to
        }
        skuEditPatterns {
          id
          editPattern {
            displayName
            lead
            image
          }
        }
        skuColorPatterns {
          id
          colorPattern {
            displayName
            lead
            type
            image
          }
        }
        composition
        materialName
        skuImages {
          id
          caption
          displayOrder
          thumbnail
          imageType
        }
        firstOptions {
          id
          displayName
          selectable
          thumbnail
          lead
        }
        allSkuEditPatterns {
          id
          editPattern {
            displayName
            lead
            image
          }
        }
      }
      searchTags {
        displayName
        categoryUrl
        firstConditionValue
        secondConditionType
        secondConditionValue
      },
      product {
        id
        categoryId
        category {
          displayName
          url
        }
        industry {
          industryName
        }
        brand
        brandName
        description
        displayName
        precaution
        hasAddonProducts
        hasOptions
        fastShippingProductId
        normalProductId
        fastShippingMarkup
        plainGoodFastShippingMarkup
        gender
        lowestPrice
        publishStatus
        productCardItems {
          productCardDisplayName
          color
        }
        plainGoodFastShipping
      }
    }
  }
`
export const productEstimateQuery = gql`
  query productEstimate(
    $id: ID!,
    $sizes: String,
    $firstOptionId: ID,
    $skuColorPatternId: ID,
    $skuEditPatternId: ID,
    $psi: ID,
    $addonProductId: ID,
    $addonFirstOptionId: ID,
    $addonPsi: ID,
    $prefectureId: ID,
    $optionIds: [ID!]
  ) {
    productByPrintableSku(
      id: $id,
      sizes: $sizes,
      firstOptionId: $firstOptionId,
      skuColorPatternId: $skuColorPatternId,
      skuEditPatternId: $skuEditPatternId,
      psi: $psi,
      addonProductId: $addonProductId,
      addonFirstOptionId: $addonFirstOptionId,
      addonPsi: $addonPsi,
      resetInvalidSizeInput: true,
      prefectureId: $prefectureId,
      optionIds: $optionIds
    ) {
      estimate {
        sizeItems {
          quantity
          sizeId
          sizeName
        }
        productId
        amount
        printableSkuId
        quantity
        quantityUnit
        shortestShippingDate
        convenienceStoreShortestShippingDate
        shortestDeliveryDate
        convenienceStoreShortestDeliveryDate
        plateChargeTaxIncluded
        productUnitPriceTaxIncluded
        unitPriceTaxIncluded
        productPriceTaxIncluded
        addonPriceTaxIncluded
        printingPriceTaxIncluded
        fastShippingFeeTaxIncluded
        fastShippingUnitFeeTaxIncluded
        addonPrintableSkuId
        selectedAddonProductId
        selectedAddonProductName
        selectedAddonFirstOptionId
        selectedAddonQuantityUnit
        addonProductUnitPriceTaxIncluded
        firstSelectedOption {
          id
          displayName
          skuSelection {
            displayName
          }
        }
        secondSelectedOption {
          id
        }
        wrappingSelectedOption {
          id
        }
        selectedColorPattern {
          id
          colorPattern {
            displayName
            lead
            type
            image
          }
        }
        selectedEditPattern {
          id
          editPattern {
            displayName
            lead
            image
          }
        }
        options {
          id
          displayName
          priceTaxIncluded
          totalPriceTaxIncluded
        }
      }
    }
  }
`

export const addToEstimateMutation = gql`
  mutation addToEstimate($input: CreateEstimateItemInput!) {
    createEstimateItem(input: $input) {
      success
      errors
    }
  }
`

export const addonProductsQuery = gql`
  query addonProductsResolver($productId: ID!) {
    addonProducts(productId: $productId) {
      product{
        id
        displayName
        quantityUnit
      }
      sku{
        firstOptions{
          id
          displayName
          thumbnail
          hasStock
        }
      }
      estimate{
        productUnitPriceTaxIncluded
      }
      addonDescription
      addonAttributes
    }
  }
`

export const prefecturesQuery = gql`
  query prefecturesResolver {
    prefectures {
      id
      name
    }
  }
`

export const deliveryDatesQuery = gql`
  query deliveryDatesResolver(
    $id: ID!,
    $sizes: String,
    $firstOptionId: ID,
    $skuColorPatternId: ID,
    $skuEditPatternId: ID,
    $psi: ID,
    $addonProductId: ID,
    $addonFirstOptionId: ID,
    $addonPsi: ID
    $prefectureId: ID
  ) {
    productByPrintableSku(
      id: $id,
      sizes: $sizes,
      firstOptionId: $firstOptionId,
      skuColorPatternId: $skuColorPatternId,
      skuEditPatternId: $skuEditPatternId,
      psi: $psi,
      addonProductId: $addonProductId,
      addonFirstOptionId: $addonFirstOptionId,
      addonPsi: $addonPsi,
      prefectureId: $prefectureId,
      resetInvalidSizeInput: true
    ) {
      estimate {
        shortestDeliveryDate
        convenienceStoreShortestDeliveryDate
      }
    }
  }
`
export const additionalOptionsQuery = gql`
  query additionalOptionsResolver($productId: ID!) {
    productOptions(productId: $productId) {
      id
      displayName
      attribute1
      attribute2
      image
      priceTaxIncluded
      totalPriceTaxIncluded
    }
  }
`

export const productRelatedCategoriesQuery = gql`
  query getProductRelatedCategories($productId: ID!) {
    productRelatedCategories(productId: $productId) {
      shortDisplayName
      url
      iconImage
    }
  }
`

export const requestRestockSizeMutation = gql`
  mutation createUserSizeRequest($input: CreateUserSizeRequestInput!) {
    createUserSizeRequest(input: $input) {
      clientMutationId
      errors
      success
    }
  }
`
